// extracted by mini-css-extract-plugin
export default {"PhotoCropInput":"bgr_a"};